import React, { useState, useRef } from "react";
import { Link } from "@reach/router";
import { AppBar, Badge, Box, CssBaseline, IconButton, Menu, MenuItem, Popover, Toolbar, Typography, Button } from "@mui/material";
import { config } from "config";
import { DehazeRounded, LogoutOutlined, PersonOutline } from "@mui/icons-material";
import { useMsal } from "@azure/msal-react";


const isActive = ({ isCurrent }: any) => {
    return isCurrent
        ? { className: "active nav-link" }
        : { className: "nav-link" };
};
// `getProps` Calls up to you to get props for the underlying anchor element.
// Useful for styling the anchor as active.
const ExactNavLink = (props: any) => <Link getProps={isActive} {...props} />;

function NavBar() {
    const [auth, setAuth] = React.useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const { instance, accounts } = useMsal();

    var appEnv = (
        <></>
    );
    if (config.REACT_APP_ENV !== "prod") {
        appEnv = (
            <>
                &nbsp;({config.REACT_APP_ENV})
            </>
        );
    }

    const activeAccount = accounts[0];
    const userName = activeAccount?.name ?? activeAccount?.username ?? "";

    function handleLogout() {
        // Clear the MSAL cache/session and redirect to the login page.
        instance.logoutRedirect({
            account: activeAccount,
            postLogoutRedirectUri: window.location.origin,
        });
    }

    return (
        <Box sx={{backgroundColor:"#FFFFFA"}}>
            <Toolbar>
                <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    align="center"
                    sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                    Gestion des structures Colas
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PersonOutline fontSize="small" />
                    <Typography variant="body2" noWrap>
                        {userName}
                    </Typography>
                    <Button
                        onClick={handleLogout}
                        startIcon={<LogoutOutlined />}
                        size="small"
                        color="inherit"
                        sx={{ textTransform: "none" }}
                    >
                        Déconnexion
                    </Button>
                </Box>
            </Toolbar>
        </Box>

    );
}

export default NavBar;
